import React from 'react';
import { ConfirmDialog } from '@personal-dashboard/ui';

interface DeletePersonDialogProps {
  open: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeletePersonDialog: React.FC<DeletePersonDialogProps> = ({
  open,
  loading,
  onConfirm,
  onCancel,
}) => {
  return (
    <ConfirmDialog
      open={open}
      title="Delete Contact"
      message="Are you sure you want to delete this contact?"
      confirmLabel="Delete"
      severity="error"
      loading={loading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default DeletePersonDialog;
